var _templateObject, _templateObject2;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
import { usePopperTooltip } from "react-popper-tooltip";
import isMobile from "is-mobile";
import { colorDarkest, colorWhite } from "@nib-components/theme";
import { Box } from "@nib/layout";
// eslint-disable-next-line no-unused-vars
export var TooltipArrow = styled(function (_ref) {
  var mode = _ref.mode,
      rest = _objectWithoutProperties(_ref, ["mode"]);

  return /*#__PURE__*/React.createElement("div", rest);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 1rem;\n  width: 1rem;\n  pointer-events: none;\n  color: ", ";\n\n  ::before {\n    content: '';\n    display: block;\n    width: 0;\n    height: 0;\n    margin: auto;\n    position: absolute;\n    border: 0.5rem solid transparent;\n  }\n"])), function (_ref2) {
  var mode = _ref2.mode;
  return mode === "dark" ? colorDarkest : colorWhite;
});
TooltipArrow.displayName = "TooltipArrow";
export var TooltipContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  z-index: 9999;\n\n  &[data-popper-placement^='top'] ", " {\n    top: 100%;\n\n    ::before {\n      border-top-color: currentColor;\n    }\n  }\n\n  &[data-popper-placement^='bottom'] ", " {\n    bottom: 100%;\n\n    ::before {\n      border-bottom-color: currentColor;\n    }\n  }\n"])), TooltipArrow, TooltipArrow);
TooltipContainer.displayName = "TooltipContainer";
export var TooltipElement = function TooltipElement(props) {
  var id = props.id,
      tooltipContents = props.tooltipContents,
      mode = props.mode,
      visible = props.visible,
      tooltipProps = props.tooltipProps,
      arrowProps = props.arrowProps;
  var isDark = mode === "dark";
  return /*#__PURE__*/React.createElement(TooltipContainer, _extends({
    id: id,
    role: "tooltip",
    hidden: !visible ? true : undefined
  }, tooltipProps), /*#__PURE__*/React.createElement(Box, {
    padding: 4,
    background: isDark ? "darkest" : "white",
    color: isDark ? "white" : "darkest",
    borderRadius: "standard",
    maxWidth: "280px"
  }, tooltipContents, /*#__PURE__*/React.createElement(TooltipArrow, _extends({
    mode: mode
  }, arrowProps))));
};

var TooltipRenderer = function TooltipRenderer(props) {
  var id = props.id,
      tooltipContents = props.tooltipContents,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? "top" : _props$placement,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? "dark" : _props$mode,
      children = props.children;

  var _usePopperTooltip = usePopperTooltip({
    placement: placement,
    trigger: [isMobile() ? "click" : "hover", "focus"]
  }, {
    modifiers: [{
      name: "preventOverflow",
      options: {
        padding: 16
      }
    }, {
      name: "offset",
      options: {
        offset: [0, 16]
      }
    }]
  }),
      getArrowProps = _usePopperTooltip.getArrowProps,
      getTooltipProps = _usePopperTooltip.getTooltipProps,
      setTooltipRef = _usePopperTooltip.setTooltipRef,
      setTriggerRef = _usePopperTooltip.setTriggerRef,
      triggerRef = _usePopperTooltip.triggerRef,
      visible = _usePopperTooltip.visible;

  return /*#__PURE__*/React.createElement(React.Fragment, null, children({
    triggerProps: {
      tabIndex: 0,
      ref: setTriggerRef,
      "aria-describedby": id
    }
  }), triggerRef && /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(TooltipElement, {
    id: id,
    mode: mode,
    placement: placement,
    visible: visible,
    tooltipProps: getTooltipProps({
      className: "tooltip-container",
      ref: setTooltipRef
    }),
    arrowProps: getArrowProps(),
    tooltipContents: tooltipContents
  }), document.body));
};

export default TooltipRenderer;